import {
  jb_language_alert_css_default
} from "./chunk.U5IBBALZ.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  JBCookie
} from "./chunk.NKAUZW5M.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n,
  r as r2
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-language-alert/jb-language-alert.ts
var JbLanguageAlert = class extends r {
  constructor() {
    super(...arguments);
    this.texts = {};
    this._isShowing = true;
    this._isVisible = false;
    this._text = "";
  }
  events() {
    window.addEventListener("scroll", () => {
      if (window.pageYOffset > 0) {
        if (!this._isShowing) {
          this._isVisible = false;
        } else {
          this._isShowing = false;
        }
      }
    });
  }
  firstUpdated() {
    this.showLanguageAlert();
  }
  getCurrentPageLanguage() {
    return document.querySelector("html").getAttribute("lang");
  }
  shouldBeShown() {
    if (this.forceAlert) {
      return true;
    }
    const cookieLanguage = JBCookie.getI18nCookieData().languageIso2;
    if (!cookieLanguage) {
      return false;
    }
    const currentPageLanguage = this.getCurrentPageLanguage();
    if (!currentPageLanguage) {
      return false;
    }
    return currentPageLanguage !== cookieLanguage;
  }
  showLanguageAlert() {
    if (!this.shouldBeShown()) {
      return;
    }
    this._isVisible = true;
    const languageId = JBCookie.getI18nCookieData().language;
    this._text = this.texts[`language${languageId}`] ?? this.texts.language0;
    this.events();
    setTimeout(() => {
      this._isVisible = false;
    }, 4e3);
  }
  render() {
    const classes = {
      hidden: !this._isVisible
    };
    return ke`
      <section
        class="${Rt(classes)}"
        data-nosnippet
      >
        <p>${ae(this._text)}</p>
      </section>
    `;
  }
};
JbLanguageAlert.styles = [reset_css_default, jb_language_alert_css_default];
__decorateClass([
  n({ type: Boolean })
], JbLanguageAlert.prototype, "forceAlert", 2);
__decorateClass([
  n({ type: Object })
], JbLanguageAlert.prototype, "texts", 2);
__decorateClass([
  r2()
], JbLanguageAlert.prototype, "_isVisible", 2);
__decorateClass([
  r2()
], JbLanguageAlert.prototype, "_text", 2);
JbLanguageAlert = __decorateClass([
  customElement("jb-language-alert")
], JbLanguageAlert);

export {
  JbLanguageAlert
};
